import { BroadcastChannelManager } from './BroadcastChannelManager';

interface IBroadcastCounterManagerOptions {
  channelName: string;
  storageKey: string;
  initialValue?: number;
}

/**
 * Specialized BroadcastChannelManager for numeric counters with
 * convenience methods for increment and reset operations.
 *
 * @example
 * const counter = new BroadcastCounterManager({
 *   channelName: 'store-refresh',
 *   storageKey: 'store-refresh-count',
 * });
 * counter.increment();
 * console.log(counter.getCount()); // 1
 */
export class BroadcastCounterManager extends BroadcastChannelManager<number> {
  constructor(options: IBroadcastCounterManagerOptions) {
    super({
      channelName: options.channelName,
      storageKey: options.storageKey,
      initialValue: options.initialValue ?? 0,
      serialize: (value: number): string => String(value),
      deserialize: (raw: string): number => parseInt(raw, 10),
    });
  }

  getCount(): number {
    return this.getValue();
  }

  increment(): number {
    const next = this.getValue() + 1;
    this.setValue(next);
    return next;
  }

  reset(): void {
    this.setValue(0);
  }
}
